import { useCurrentEnterpriseId } from "@app/hooks/useCurrentEnterpriseId.ts";
import { trpc } from "@app/trpc.ts";
import { useQuery } from "@tanstack/react-query";

export function useEnterpriseModules({ enabled }: { enabled: boolean }) {
  const { enterpriseId, isLoading: isLoadingEnterpriseId } =
    useCurrentEnterpriseId();
  const {
    data: modules,
    isLoading: isLoadingModules,
    isError,
    refetch,
  } = useQuery({
    ...trpc.enterprises.modules.queryOptions({
      enterpriseId: enterpriseId ?? "",
    }),
    enabled: enabled && !!enterpriseId,
  });

  return {
    modules,
    isError,
    refetch,
    isLoading: enabled && (isLoadingEnterpriseId || isLoadingModules),
  };
}
